var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_Icon_Delete",
    "data-name": "[Icon] Delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 12.444 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-forever",
    "data-name": "Icon material-delete-forever",
    d: "M8.389,18.722A1.783,1.783,0,0,0,10.167,20.5h7.111a1.783,1.783,0,0,0,1.778-1.778V8.056H8.389Zm2.187-6.329,1.253-1.253,1.893,1.884,1.884-1.884,1.253,1.253-1.884,1.884,1.884,1.884-1.253,1.253-1.884-1.884-1.884,1.884-1.253-1.253,1.884-1.884Zm6.258-7L15.944,4.5H11.5l-.889.889H7.5V7.167H19.944V5.389Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#193C6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.fbf368f958eebadd19295a325435bc29.svg";
export { ForwardRef as ReactComponent };